module.exports = __webpack_public_path__ + "static/better-broker-mobile-bkgrd-0db987ca95b9137d7f85e42f3a5b9dd0.png";